<template>
  <div v-if="visible" class="app-modal-overlay v--modal-overlay" @click="handleOverlayClick">
    <div class="app-modal-box" :style="modalStyle" @click.stop>
      <div class="app-modal-container v--modal">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { getModalApi } from '@/plugins/modal-manager';

export default {
  name: 'modal',
  props: {
    name: {
      type: String,
      required: true
    },
    clickToClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: [String, Number],
      default: '50%'
    },
    height: {
      type: [String, Number],
      default: 'auto'
    }
  },
  data () {
    return {
      modalApi: getModalApi(),
      wasVisible: false
    };
  },
  computed: {
    visible () {
      return this.modalApi.isVisible(this.name);
    },
    modalStyle () {
      return {
        width: this.normalizeDimension(this.width),
        height: this.normalizeDimension(this.height),
        maxHeight: '90vh'
      };
    }
  },
  watch: {
    visible (nextVisible, previousVisible) {
      if (!nextVisible && previousVisible) {
        this.$emit('closed');
      }
    }
  },
  methods: {
    normalizeDimension (value) {
      if (typeof value === 'number') {
        return `${value}px`;
      }
      return value || 'auto';
    },
    handleOverlayClick () {
      if (this.clickToClose) {
        this.modalApi.hide(this.name);
      }
    }
  }
};
</script>

<style scoped>
.app-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
}

.app-modal-container {
  background: #ffffff;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: auto;
  width: 100%;
  height: 100%;
}

.app-modal-box {
  max-width: calc(100vw - 32px);
}
</style>
